import { connect } from 'react-redux';
import TransacaoTempoReal from './transacaoTempoReal';

export default connect()(TransacaoTempoReal);
